module.exports = __webpack_public_path__ + "img/entitys.19794093.svg";